import './authUrlPreflight';
import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';
import en from './translation/en.json';
import { loadTranslation, translationBackend } from './translationLoader';
import { consumeEntryLocale, ENTRY_LANGUAGE_CODES } from '@/Config/app/entryLocale';

export const defaultNS = 'translation';

const entryLocale = consumeEntryLocale();

// eslint-disable-next-line import/no-named-as-default-member
await i18n
  .use(initReactI18next)
  .use(LanguageDetector)
  .use(translationBackend)
  .init({
    fallbackLng: 'en',
    supportedLngs: ENTRY_LANGUAGE_CODES,
    lowerCaseLng: true,
    lng: entryLocale,
    defaultNS,
    ns: Object.keys(en),
    partialBundledLanguages: true,
    load: 'currentOnly',
    debug: process.env.NODE_ENV === 'development',
    saveMissing: true,
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
    resources: { en },
    detection: {
      order: ['localStorage', 'querystring'],
      lookupLocalStorage: '__qc_i18nextLng',
      lookupQuerystring: 'lang',
      // supportedLngs alone still admits i18next's built-in 'cimode', which renders raw keys.
      convertDetectedLanguage: (language) =>
        ENTRY_LANGUAGE_CODES.includes(language) ? language : '',
      caches: ['localStorage'],
    },
  })
  .catch(() => {});

if (i18n.services.formatter) {
  i18n.services.formatter.add(
    'capitalize',
    (value = '') => `${value.substr(0, 1).toUpperCase()}${value.substr(1)}`,
  );
}

export const changeAppLanguage = async (language: string): Promise<void> => {
  const resources = await loadTranslation(language);
  for (const namespace of Object.keys(en)) {
    if (!i18n.hasResourceBundle(language, namespace)) {
      i18n.addResourceBundle(language, namespace, resources[namespace] ?? {});
    }
  }
  // eslint-disable-next-line import/no-named-as-default-member
  await i18n.changeLanguage(language);
};

export default i18n;
